import * as $ from 'jquery';

const oldjquery = (window as any).jQuery;
(window as any).jQuery = $;
import './jquery-ui-sortable';
(window as any).jQuery = oldjquery;


// WEBPACK FOOTER //
// ./lib/jquery-ui-sortable-loader.ts